"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var myregexp_1 = __importDefault(require("myregexp"));
var Result_1 = require("../../../../../models/concrete/Result");
var UserValidationService = /** @class */ (function () {
    function UserValidationService() {
        this.schemaForSignUp = joi_1.default.object().keys({
            name: joi_1.default.string().required(),
            phone: joi_1.default.string().required().regex(myregexp_1.default.phone())
        });
        this.schemaForRequestPassword = joi_1.default.object().keys({
            phone: joi_1.default.string().optional().regex(myregexp_1.default.phone()),
            email: joi_1.default.string().optional().regex(myregexp_1.default.email())
        });
        this.schemaForSignIn = joi_1.default.object().keys({
            username: joi_1.default.string().required(),
            password: joi_1.default.string().required()
        });
        this.schemaForGetUser = joi_1.default.object().keys({
            username: joi_1.default.string().optional(),
            phone: joi_1.default.string().optional().regex(myregexp_1.default.phone()),
            expanded: joi_1.default.boolean().optional()
        });
        this.schemaForUpdateUser = joi_1.default.object().keys({
            name: joi_1.default.string().optional(),
            address: joi_1.default.string().optional(),
            sex: joi_1.default.number().valid(0, 1, 2).optional(),
            birthday: joi_1.default.date().iso().optional()
        });
        this.schemaForSetUserAvatar = joi_1.default.object().keys({
            data: joi_1.default.any().required()
        });
    }
    UserValidationService.prototype.signUpData = function (data) {
        var error = this.schemaForSignUp.validate(data).error;
        // debug
        console.debug('Validating sign up data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    UserValidationService.prototype.requestPasswordData = function (data) {
        var error = this.schemaForRequestPassword.validate(data).error;
        // debug
        console.debug('Validating request password data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    UserValidationService.prototype.signInData = function (data) {
        var error = this.schemaForSignIn.validate(data).error;
        // debug
        console.debug('Validating sign in data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    UserValidationService.prototype.getUserData = function (data) {
        var error = this.schemaForGetUser.validate(data).error;
        // debug
        console.debug('Validating get user data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    UserValidationService.prototype.updateUserData = function (data) {
        var error = this.schemaForUpdateUser.validate(data).error;
        // debug
        console.debug('Validating update user data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    UserValidationService.prototype.setUserAvatarData = function (data) {
        var error = this.schemaForSetUserAvatar.validate(data).error;
        // debug
        console.debug('Validating set user avatar data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return UserValidationService;
}());
exports.UserValidationService = UserValidationService;
;
//# sourceMappingURL=UserValidationService.js.map